// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"upcommingEvent_wrapper__34AU4","showScroll":"upcommingEvent_showScroll__1YzVU","btnWrp":"upcommingEvent_btnWrp__2A5dL"};